import { authService } from './auth';
import { updateUser as dbUpdateUser } from './db';

const AVATAR_EMOJIS = [
  '😎', '🤠', '🧐', '😤', '🤑', '🦊', '🐺', '🦁', '🐸', '🤖',
  '👻', '🎃', '🧙', '🥷', '🦸', '🧛', '🤡', '👽', '🦄', '🐉',
  '🏴‍☠️', '🎭', '🎪', '🎯', '🏆', '⚽', '🎲', '🃏', '🧊', '💎',
];

async function syncProfileToDb(userId, updates) {
  try {
    const localUser = authService.getAllUsers().find((u) => u.id === userId);
    if (!localUser) return;

    // Local users are hydrated from DynamoDB, so their id is the row's key. Looking the
    // row up again by cognitoId could pick a duplicate row instead.
    await dbUpdateUser(localUser.id, updates);
    console.log('[profile] Synced profile to DynamoDB:', localUser.id);
  } catch (err) {
    console.warn('[profile] DynamoDB profile sync failed:', err);
  }
}

export const profileService = {
  getAvatarOptions() {
    return AVATAR_EMOJIS;
  },

  updateProfile(userId, { nickname, avatar, avatarType }) {
    const updates = {};
    if (nickname !== undefined) updates.displayName = nickname;
    if (avatar !== undefined) updates.avatar = avatar;
    if (avatarType !== undefined) updates.avatarType = avatarType;
    // localStorage
    const result = authService.updateUser(userId, updates);
    // DynamoDB (fire-and-forget)
    syncProfileToDb(userId, updates);
    return result;
  },

  setAvatarEmoji(userId, emoji) {
    const updates = { avatar: emoji, avatarType: 'emoji' };
    const result = authService.updateUser(userId, updates);
    syncProfileToDb(userId, updates);
    return result;
  },

  setAvatarUpload(userId, dataUrl) {
    const updates = { avatar: dataUrl, avatarType: 'upload' };
    const result = authService.updateUser(userId, updates);
    syncProfileToDb(userId, updates);
    return result;
  },
};
